<template>
  <div class="scoped-message-container">
    <div class="line"></div>
    <div class="scoped-message-content">
      <TextBody tag="span" i18n-key="conversation.contextMessage.nowTalkingTo" :body-type="2"></TextBody>
      <BbIcon size="small" :name="iconName" class="source-icon" type="outlined" />
      <span v-if="isNotDefaultCollection" class="collection-name" @click="openCollection">
        {{ collectionName }}
      </span>
      <span v-else class="collection-name-default">{{ collectionName }}</span>
      <span v-if="documentCount" />
      <span v-if="documentCount" class="documents-count">{{ documentCount }}</span>
    </div>
    <div class="line"></div>
    <WarningPopup
      :popup-opened="missingCollectionPopupOpened"
      title-key="conversation.contextMessage.somethingWentWrong"
      warning-message-key="collections.collectionNotFound"
      @update:open="missingCollectionPopupOpened = false"
      @execute:action="missingCollectionPopupOpened = false"
    />
  </div>
</template>

<script>
import { computed, ref } from 'vue';
import useCollections from '~/composables/useCollections';
import { DEFAULT_COLLECTION } from '~/constants/conversationModels';
import TextBody from '~/components/common/TextBody';
import WarningPopup from '~/components/common/WarningPopup';

export default {
  name: 'ContextMessage',
  components: { TextBody, WarningPopup },
  props: {
    // collection itself
    message: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const { openModalInCollectionScope, currentCollections } = useCollections();

    const missingCollectionPopupOpened = ref(false);

    const isNotDefaultCollection = computed(
      () => props.message.collectionId && props.message.collectionId !== DEFAULT_COLLECTION.collectionId,
    );

    const isAvailableCollection = computed(() => {
      return (
        currentCollections.value.findIndex((collection) => collection.collectionId === props.message.collectionId) > -1
      );
    });

    const iconName = computed(() => {
      return isNotDefaultCollection.value ? 'collection' : 'veeva';
    });

    const collectionName = computed(() => props.message?.collectionName?.toUpperCase() || '');

    const documentCount = computed(() => {
      const documentCount = props.message.documents?.length;
      return isNotDefaultCollection.value ? ` ${documentCount} DOCUMENTS` : '';
    });

    const openCollection = () => {
      if (!isAvailableCollection.value) {
        missingCollectionPopupOpened.value = true;
        return;
      }
      if (isNotDefaultCollection.value) {
        openModalInCollectionScope(props.message.collectionId, props.message.collectionName);
      }
    };

    return {
      collectionName,
      documentCount,
      iconName,
      isNotDefaultCollection,
      missingCollectionPopupOpened,
      openCollection,
    };
  },
};
</script>

<style scoped lang="scss">
.scoped-message-container {
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: $bb-spacing-6;
}

.line {
  flex-grow: 1;
  height: 1px;
  background-color: $bb-neutral-4;
  margin: 0 $bb-spacing-2;
}

.scoped-message-content {
  display: flex;
  align-items: center;
  white-space: nowrap;
  gap: $bb-spacing-1;
}

.collection-name {
  @include bb-regular-text-styles('lg');
  font-weight: 500;
  margin-left: $bb-spacing-1;
  cursor: pointer;
  text-decoration: underline;
}

.collection-name-default {
  @include bb-regular-text-styles('lg');
  font-weight: 500;
  margin-left: $bb-spacing-1;
  text-decoration: underline;
}

.documents-count {
  @include bb-regular-text-styles('lg');
}

.source-icon {
}
</style>
